import Switch from 'lib/components/Switch/Switch'

export default Switch
